import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { getFaqs } from 'store/faq';
import AnimatedTabs from 'components/ui/AnimatedTabs';
import { getTerms } from 'store/terms';
import { updateTitle } from 'store/app';

const Terms = () => {
  const { t } = useTranslation();

  const dispatch = useDispatch();

  const { list: terms } = useSelector(state => state.terms);
  const { language } = useSelector((state) => state.app);

  const [loading, setLoading] = useState(true);

  const fetchList = () => {
    dispatch(getTerms())
      .then(() => {
        setLoading(false)
      })
      .catch(() => {
        setLoading(false)
      })
  }

  useEffect(() => {
    dispatch(updateTitle(t('terms.label')))
    fetchList();
  }, [])

  if (loading || !terms) {
    return (
      <div className="px-8 grid grid-cols-1 gap-5 overflow-y-scroll pb-6 animate-pulse pt-20">
        <div className="h-16 bg-gray-300 rounded-lg w-full" />
        <div className="h-16 bg-gray-300 rounded-lg w-full" />
        <div className="h-16 bg-gray-300 rounded-lg w-full" />
        <div className="h-16 bg-gray-300 rounded-lg w-full" />
      </div>
    );
  }

  return (
    terms &&
    <div className="h-full w-full px-8 pb-5 pt-10 flex flex-col gap-12">
      <div dangerouslySetInnerHTML={{ __html: terms?.text[language]}} />
    </div>
  )
}

export default Terms;